var service = 'entidade';

angular.module('eficienciaFiscalModule')
    .service(service + 'Service', ['$timeout', '$filter', 'genericServiceHelper', 'httpService', 'pathService',
        function ($timeout, $filter, serviceHelper, httpService, pathService) {

            var helper = serviceHelper({
                url: '/entidade/search',
                screenId: '#eficiencia-fiscal',
                service: {}
            });

            var route = pathService.getApiUrl() + '/entidade/entidade/',
                routeSearch = pathService.getApiUrl() + '/entidade/search',
                screenId = "#entidade",
                formatDate = function (data) {
                    if (!/\d{2}\/\d{2}\/\d{4}/.test(data))
                        return data;
                    data = data.split('/');
                    return new Date(data[2], data[1] - 1, data[0]);
                },
                getFunction = function (_function, _blockScreen, _blockScreenExt, params) {
                    params = params || ['data', 'callback', 'event', 'loadText', 'blockScreen', 'blockScreenExt', 'loadingTop'];
                    var paramsObj = {};
                    params.each(function (value, index) {
                        paramsObj[value] = index
                    });
                    params = paramsObj;
                    return function () {
                        var args = arguments;
                        args[params['data']] = args[params['data']] || {};
                        args[params['data']]['function'] = _function;
                        return httpService.request({
                            url: route,
                            method: "PUT",
                            data: args[params['data']],
                            blockScreen: args[params['blockScreen']] != undefined ? args[params['blockScreen']] : (_blockScreen != undefined ? _blockScreen : true),
                            blockScreenExt: args[params['blockScreenExt']] != undefined ? args[params['blockScreenExt']] : (_blockScreenExt != undefined ? _blockScreenExt : false),
                            screenId: screenId,
                            clickEvent: args[params['event']],
                            loadingText: args[params['loadText']],
                            loadingTop: args[params['loadingTop']],
                            onSuccess: function (data) {
                                if (args[params['callback']])
                                    args[params['callback']](data);
                            }
                        })
                    }
                };

            this.createUser = getFunction('criar_usuario');
            this.createUsers = getFunction('criar_usuarios');
            this.resetPasswordUser = getFunction('resetar_senha_usuario');
            this.gerenciarTipo = getFunction('gerenciar_tipo');
            this.changeStatus = getFunction('ativar_desativar_usuario');

            this.getConfigInputs = function (tipo, callback) {
                httpService.request({
                    method: "GET",
                    url: pathService.getApiUrl() + '/entidade/tipo/' + tipo,
                    blockScreen: true,
                    screenId: '#entidade',
                    onSuccess: function (data) {
                        if (callback)
                            callback(data[0]);
                    }
                })
            };

            this.search = function (data, callback, event, loadText, blockScreen, loadingTop) {
                if (!data.consulta)
                    data.consulta = 'entidades';

                return httpService.request({
                    url: routeSearch,
                    data: data,
                    method: "POST",
                    blockScreen: blockScreen || true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    loadingTop: loadingTop || false,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };

            this.searchPagination = function (params, callback, event, loadText) {
                return helper.search(params, callback, event, loadText);
            };

            this.searchList = function (params, callback, event, loadText, blockScreen, loadingTop) {
                var url = route + '?';
                for (var key in params)
                    if (params.hasOwnProperty(key) && params[key] != undefined && (params[key].length == undefined || params[key].length > 0)) {
                        if (Array.isArray(params[key]))
                            params[key].each(function (value) {
                                url += key + '[]=' + value + '&';

                            });
                        else
                            url += key + '=' + params[key] + '&';
                    }

                return httpService.request({
                    url: url,
                    method: "GET",
                    blockScreen: blockScreen != undefined ? blockScreen : true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    loadingTop: loadingTop || false,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };


            this.select2Options = function (tipos) {
                var options = {
                    formatSearching: function () {
                        return 'Pesquisando...';
                    },
                    formatNoMatches: function (term) {
                        return "Nenhum resultado para '" + term + "'";
                    },
                    formatInputTooShort: function (term, minLength) {
                        return "Por favor entre com mais " + (minLength - term.length) + ((minLength - term.length == 1) ? " caractere" : " caracteres");
                    },
                    minimumInputLength: 3,
                    ajax: {
                        type: "post",
                        url: routeSearch,
                        data: function (term, page) {
                            return {
                                consulta: 'entidades',
                                tipos: tipos,
                                nome: term,
                                limit: 10
                            };
                        },
                        results: function (data, page) {
                            var lista = [];
                            angular.forEach(data, function (value, index) {
                                lista.push(
                                    {
                                        id: value.id,
                                        text: value.nome
                                    }
                                );
                            });
                            return {results: lista};
                        }
                    }
                };
                return options;
            };

            this.getListByTipo = function (tipo, callback, event) {
                httpService.request({
                    method: "POST",
                    url: routeSearch,
                    data: {
                        consulta: 'entidades',
                        tipos: [tipo]
                    },
                    blockScreenExt: true,
                    screenId: '#entidade',
                    clickEvent: event,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };

            this.searchEntidades = function (data, callback, event, blockScreenExt) {

                return httpService.request({
                    method: "POST",
                    url: routeSearch,
                    data: data,
                    screenId: '#entidade',
                    loadingText: 'Buscando cadastros...',
                    loadingTop: true,
                    clickEvent: event,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };

            this.searchEntidadesByQuery = function (data, callback, event) {
                data.consulta = 'searchEntidadesByQuery';
                return httpService.request({
                    method: "POST",
                    url: pathService.getApiUrl() + '/entidade/search',
                    data: data,
                    blockScreenExt: true,
                    screenId: '#entidade',
                    clickEvent: event,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };

            var searchTipoByEntidade = this.searchTipoByEntidade = function (data, callback, event) {
                data.consulta = 'searchTipoByEntidade';
                return httpService.request({
                    method: "POST",
                    url: pathService.getApiUrl() + '/entidade/search',
                    data: data,
                    blockScreenExt: true,
                    screenId: '#entidade',
                    clickEvent: event,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };

            this.abrirEntidade = function (id, event) {
                searchTipoByEntidade({id: id}, function (tipo) {
                    tipo = tipo.replace(/"/g, '');
                    cbk.abrirPopup(null, pathService.urlDomain + '/entidade/' + '#/detalhes/' + tipo + '/' + id)
                }, event);
            };

            this.getList = function (callback, event, loadText) {
                httpService.request({
                    url: route,
                    method: "GET",
                    blockScreen: true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };

            this.get = function (id, callback, event, loadText, blockScreen, loadingTop) {
                httpService.request({
                    url: route + id,
                    method: "GET",
                    blockScreen: blockScreen || true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    loadingTop: loadingTop || false,
                    onSuccess: function (data) {
                        data.rgEmissao = (data.rgEmissao == undefined) ? undefined : $filter('date')(data.rgEmissao, 'dd/MM/yyyy');
                        data.dataNascimento = (data.dataNascimento == undefined) ? undefined : $filter('date')(data.dataNascimento, 'dd/MM/yyyy');
                        if (callback)
                            callback(data);
                    }
                })
            };

            this.save = function (data, event, callback, loadText) {
                data.dataNascimento = formatDate(data.dataNascimento);
                data.rgEmissao = formatDate(data.rgEmissao);

                if (data.subtipos != undefined && data.subtipos.length > 0) {
                    var subtipos = [];
                    angular.forEach(data.subtipos, function (value) {
                        subtipos.push(value.id)
                    });
                    data.subtipos = subtipos;
                }
                httpService.request({
                    url: route,
                    method: "POST",
                    data: data,
                    blockScreen: true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };

            this.update = function (data, callback, event, loadText) {
                data.unidade = data.unidade.id;
                data.cidade = data.cidade ? data.cidade.id : undefined;
                data.cidadeNatal = data.cidadeNatal ? data.cidadeNatal.id : undefined;
                data.dataNascimento = formatDate(data.dataNascimento);
                data.rgEmissao = formatDate(data.rgEmissao);
                data.entidadeTipos = undefined;
                if (data.usuario != undefined)
                    data.usuario = {displayName: data.usuario.displayName};
                return httpService.request({
                    url: route + data.id,
                    method: "PUT",
                    data: data,
                    blockScreen: true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };

            this.delete = function (id, callback, event, loadText) {
                httpService.request({
                    url: route + id,
                    method: "DELETE",
                    blockScreen: true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            };

            this.fieldValidator = function (data, field, callback) {
                httpService.request({
                    method: 'POST',
                    url: '/p/entidade/entidades/validar',
                    data: data,
                    onSuccess: callback
                })
            }
        }
    ]);
